<script>import { onDestroy, onMount } from "svelte";
import { remainingTime } from "../../utils/date";
export let endDateString;
export let whenCountdownEnds = void 0;
export let monthsLabel = null;
export let daysLabel = null;
export let hoursLabel = null;
export let minutesLabel = null;
export let secondsLabel = null;
export let duration;
let countdown;
let interval;
$: duration && (countdown = {
  months: {
    value: duration.months,
    label: monthsLabel
  },
  days: {
    value: duration.days,
    label: daysLabel
  },
  hours: {
    value: duration.hours,
    label: hoursLabel
  },
  minutes: {
    value: duration.minutes,
    label: minutesLabel
  },
  seconds: {
    value: duration.seconds ?? 0,
    label: secondsLabel
  }
});
const updateCountdown = () => {
  duration = remainingTime(endDateString);
  if (!duration.months && !duration.days && !duration.hours && !duration.minutes && !duration.seconds) {
    clearInterval(interval);
    whenCountdownEnds && whenCountdownEnds();
  }
};
onMount(() => {
  updateCountdown();
  interval = setInterval(updateCountdown, 1e3);
});
onDestroy(() => {
  if (interval) {
    clearInterval(interval);
  }
});
</script>

{#if duration}
	<div class="flex space-x-2 lg:space-x-3">
		{#each Object.entries(countdown) as [key, val]}
			{#if val.value || (key === 'seconds' && val.value === 0)}
					<div class="text-center">
						<div class="font-bold text-xl">{val.value}</div>
						<div class="text-sm xl:text-xs 2xl:text-sm">
							{val.label}
						</div>
					</div>
			{/if}
		{/each}
	</div>
{/if}
